(function () {
    'use strict';
    angular.module('Directives').directive('bbaOperationHrs', bbaOperationHrs);
    bbaOperationHrs.$inject = [];

    function bbaOperationHrs() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/form-components/bba-operation-hrs-input.html',
            replace: true,
            scope: {
                ngModel: '='
            },
            link: bbaOperationHrsLink
        }

        function bbaOperationHrsLink($scope) {
            $scope.weekDays = [
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday',
                'sunday'
            ];
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/form-components/bbaOperationHrs.js